if (!customElements.get('header-sticky')) {
  class HeaderSticky extends HTMLElement {
    constructor() {
      super();

      this.wrapper = this.closest('.header-wrapper');
      this.mobileBreakpoint = '(max-width: 989px)';
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    attachEvents() {
      ['load', 'scroll', 'resize'].forEach((eventName) => {
        window.addEventListener(eventName, this.init.bind(this));
      });
    }

    init() {
      let headerBodyBottomPosition = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--header-body-bottom-position',
        ),
      );

      let announcementBarHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--announcement-bar-height',
          ),
        ) || 0;

      if (window.matchMedia(this.mobileBreakpoint).matches) {
        headerBodyBottomPosition = 0;
      }

      this.wrapper.classList.toggle(
        'header-wrapper--sticky',
        window.scrollY > headerBodyBottomPosition + announcementBarHeight,
      );

      document.body.classList.toggle(
        'header-is-sticky',
        window.scrollY > headerBodyBottomPosition + announcementBarHeight,
      );
    }
  }

  customElements.define('header-sticky', HeaderSticky);
}
